"use client";
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareMenu = void 0;
const react_1 = __importDefault(require("react"));
const useWarning_1 = require("../../hooks/useWarning");
const Notification_1 = require("../Notification");
const DesktopShareMenu_1 = require("./DesktopShareMenu");
const MobileShareMenu_1 = require("./MobileShareMenu");
const copyLinkToClipboard = (link) => __awaiter(void 0, void 0, void 0, function* () {
    yield navigator.clipboard.writeText(link || window.location.href);
});
const ShareMenu = ({ buttonLabel, buttonVariant = "primary", xClickHandler, facebookClickHandler, instagramUrl, linkedinClickHandler, copyLinkUrl }) => {
    const { warn } = (0, useWarning_1.useWarning)();
    const [isShareMenuOpen, setIsShareMenuOpen] = react_1.default.useState(false);
    const [isCopyNotificationOpen, setIsCopyNotificationOpen] = react_1.default.useState(false);
    const copyLinkClickHandler = react_1.default.useCallback(() => {
        copyLinkToClipboard(copyLinkUrl).then(() => setIsCopyNotificationOpen(true));
    }, [copyLinkUrl]);
    const shareItems = react_1.default.useMemo(() => {
        const items = [
            instagramUrl
                ? {
                    ariaLabel: "share to instagram",
                    dataTestIdDesktop: "instagram-button-desktop",
                    dataTestIdMobile: "instagram-button-mobile",
                    icon: "logo-instagram",
                    name: "Instagram",
                    clickHandler: () => {
                        window.open(encodeURI(instagramUrl), "_blank");
                    }
                }
                : undefined,
            facebookClickHandler
                ? {
                    ariaLabel: "share to facebook",
                    dataTestIdDesktop: "facebook-button-desktop",
                    dataTestIdMobile: "facebook-button-mobile",
                    icon: "logo-instagram",
                    name: "Facebook",
                    clickHandler: facebookClickHandler
                }
                : undefined,
            xClickHandler
                ? {
                    ariaLabel: "share to X",
                    dataTestIdDesktop: "x-button-desktop",
                    dataTestIdMobile: "x-button-mobile",
                    icon: "logo-x",
                    name: "X",
                    clickHandler: xClickHandler
                }
                : undefined,
            linkedinClickHandler
                ? {
                    ariaLabel: "share to linkedin",
                    dataTestIdDesktop: "linkedin-button-desktop",
                    dataTestIdMobile: "linkedin-button-mobile",
                    icon: "logo-linkedin",
                    name: "Linkedin",
                    clickHandler: linkedinClickHandler
                }
                : undefined,
            copyLinkUrl
                ? {
                    ariaLabel: "copy to clipboard",
                    dataTestIdDesktop: "copy-button-desktop",
                    dataTestIdMobile: "copy-button-mobile",
                    icon: "link",
                    name: "Copy link",
                    clickHandler: copyLinkClickHandler
                }
                : undefined
        ];
        const filteredItems = items
            .filter((item) => item)
            .map((item) => item);
        if (filteredItems.length === 5) {
            warn(`There are 5 ShareItems within the ShareMenu component. 
  This component renders a maximum of 4 share items.
  Remove one of the 5 share options to remove this warning.`);
            filteredItems.pop();
        }
        return filteredItems;
    }, [
        instagramUrl,
        facebookClickHandler,
        xClickHandler,
        linkedinClickHandler,
        copyLinkUrl,
        copyLinkClickHandler,
        warn
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Notification_1.Notification, { icon: "link", closeDelay: 1000, text: "Link copied!", isOpen: isCopyNotificationOpen, onDismiss: () => setIsCopyNotificationOpen(false), showX: false, status: "success" }),
        react_1.default.createElement(DesktopShareMenu_1.DesktopShareMenu, { isShareMenuOpen: isShareMenuOpen, setIsShareMenuOpen: setIsShareMenuOpen, shareItems: shareItems, buttonLabel: buttonLabel, buttonVariant: buttonVariant }),
        react_1.default.createElement(MobileShareMenu_1.MobileShareMenu, { isShareMenuOpen: isShareMenuOpen, setIsShareMenuOpen: setIsShareMenuOpen, shareItems: shareItems, buttonLabel: buttonLabel, buttonVariant: buttonVariant })));
};
exports.ShareMenu = ShareMenu;
//# sourceMappingURL=ShareMenu.js.map